import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {  Paper, Typography, Avatar, Box, CircularProgress, TableContainer, Table, TableBody, TableRow, TableCell } from '@mui/material';
import StudentLayout from '../../components/student/StudentLayout';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const GuardianInfo = () => {
  const [guardian, setGuardian] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const { student } = useSelector((state) => state.student);

  useEffect(() => {
    const fetchGuardian = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_KEY}api/v1/student/guardian/${student?.id}`); // ← غيّر الـ endpoint حسب مشروعك
        setGuardian(response.data.guardian);
      } catch (error) {
        console.error('Error fetching guardian info:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchGuardian();
  }, []);

  if (loading) {
    return <StudentLayout><CircularProgress /></StudentLayout>;
  }

  if (!guardian) {
    return <StudentLayout>
        <Typography color="error" className='text-center'>{t("No data for the guardian")}</Typography>
    </StudentLayout> 
  }

  return (
        <StudentLayout>
         <TableContainer component={Paper} sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell colSpan={2} align="center">
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                <Avatar src={guardian.image} alt={guardian.name} sx={{ width: 60, height: 60 }} />
                <Typography variant="h6">{guardian.name}</Typography>
              </Box>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>{t("email")}</strong></TableCell>
            <TableCell>{guardian.email}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
        </StudentLayout>

  );
};

export default GuardianInfo;
